export default [
  {
    name: 'Empresas',
    path: 'empresas',
    component: () => import('@/views/empresas/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Empresas' }
      ]
    }
  },
  {
    name: 'Empresas Editar',
    path: 'empresas/edit/:id',
    component: () => import('@/views/empresas/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Empresas', path: '/administracao/empresas' },
        { name: 'Editar' }
      ]
    }
  },
  {
    name: 'Empresas Adicionar',
    path: 'empresas/edit',
    component: () => import('@/views/empresas/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Empresas', path: '/administracao/empresas' },
        { name: 'Adicionar' }
      ]
    }
  }
]
